import gql from 'graphql-tag';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { DocumentNode } from 'graphql';

const convertDataClassificationTagsToString = (dataClassificationTagIds: string[]) => {
	return `[
    ${dataClassificationTagIds.map((id) => `"${id}"`).join(', ')}
  ]`;
};

export const getExtensionListQueryOld = (
	expandAppOwner?: boolean,
	moduleTypes?: string[],
	dataClassificationTagIds?: string[],
): DocumentNode => {
	const modules = moduleTypes?.map((m) => `"${m}"`) || ['$type'];
	const userAccessField = fg('platform-forge-ui-useraccess-in-extension-query')
		? `userAccess {
    enabled
    hasAccess
  }`
		: '';
	const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules
				.map(
					(m) => `
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${
						expandAppOwner
							? `appOwner {
            name
          }`
							: ''
					}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${
						dataClassificationTagIds && dataClassificationTagIds.length > 0
							? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${convertDataClassificationTagsToString(
										dataClassificationTagIds,
									)}
                }) {
                  status
                }
              `
							: ''
					}
        }`,
				)
				.join('')}
    }
  }`;

	return gql`
		${query}
	`;
};

export const getExtensionListQuery = (
	expandAppOwner?: boolean,
	dataClassificationTagIds?: string[],
): DocumentNode => {
	const userAccessField = fg('platform-forge-ui-useraccess-in-extension-query')
		? `userAccess {
    enabled
    hasAccess
  }`
		: '';

	const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${
					expandAppOwner
						? `appOwner {
          name
        }`
						: ''
				}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${
					dataClassificationTagIds && dataClassificationTagIds.length > 0
						? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${convertDataClassificationTagsToString(
									dataClassificationTagIds,
								)}
              }) {
                status
              }
            `
						: ''
				}
      },
    }
  }`;

	return gql`
		${query}
	`;
};

export const FetchPreFilteredForgeAppsQuery: DocumentNode = gql`
	query FetchPreFilteredForgeAppsQuery(
		$cloudId: ID!
		$context: ConfluenceExtensionRenderingContextInput
		$includeHidden: Boolean
		$locale: String
		$types: [String]
	) {
		confluence_forgeExtensionsByType(
			cloudId: $cloudId
			context: $context
			includeHidden: $includeHidden
			locale: $locale
			types: $types
		) {
			id
			appId
			appVersion
			appOwner
			environmentId
			environmentType
			environmentKey
			consentUrl
			migrationKey
			userAccess {
				enabled
				hasAccess
			}
			key
			properties {
				key
				value
			}
			egress {
				addresses
				category
				type
				inScopeEUD
			}
			sandboxPolicies
			scopes
			license {
				active
				capabilitySet
				billingPeriod
				ccpEntitlementId
				ccpEntitlementSlug
				isEvaluation
				subscriptionEndDate
				trialEndDate
				type
			}
			type
			installationId
			hiddenBy
		}
	}
`;
